export const ACTION_CODE = 'INVOICE' + '_ACTION';
